export default __webpack_public_path__ + "static/media/Jump (8).e7196bd0.png";